<template>
  <div id="menu">
    <div class="menu_shadow" v-show="matches && onOpen" @click="matchesClose"></div>
    <div class="menu_wrapper" :style="menu_wrapperStyle">
      <div class="menu_logo">
        <router-link to="/home" class="logo">
          <img alt class="logoImg" />
        </router-link>
        <img src="@/assets/images/close.png" v-if="matches" @click="matchesClose" class="menu_back" alt="image" />
      </div>
      <el-scrollbar style="height: 100%">
        <el-collapse-transition>
          <el-menu
            class="el-menu-vertical-demo"
            background-color="rgb(255, 255, 255)"
            text-color="#000d28"
            active-text-color="#000d28"
            :unique-opened="true"
            :default-active="$route.path"
          >
            <div v-for="menus in filteredMenus" v-bind:key="`menus-${menus.id}`">
              <div class="nav-title">
                <span class="nav-group__title">{{ $t(menus.name) }}</span>
              </div>
              <div v-for="menu in menus.children" v-bind:key="`menu-${menu.id}`">
                <el-menu-item
                  :index="checkHomeUrl(menu.path)"
                  v-if="checkRegister(menu)"
                  :data-testid="menu.name"
                  @click="clickMenu(menu)"
                  :class="{ 'red-dots': count != 0 && menu.name == 'menu.clubBleu' }"
                >
                  <img :src="menu.iconActive" class="icon active_icon" alt="" />
                  <img :src="menu.iconHover" class="icon hover_icon" alt="" />
                  <img :src="menu.icon" class="icon default_icon" alt="" />
                  <span slot="title">{{ $t(menu.name) }}</span>
                </el-menu-item>
                <el-submenu :index="menu.path" v-if="menu.children" :data-testid="menu.name">
                  <template slot="title">
                    <img :src="menu.iconActive" class="icon active_icon" alt="" />
                    <img :src="menu.iconHover" class="icon hover_icon" alt="" />
                    <img :src="menu.icon" class="icon default_icon" alt="" />
                    <span slot="title">{{ $t(menu.name) }}</span>
                  </template>
                  <template v-for="(children, index) in menu.children">
                    <el-menu-item
                      v-bind:key="index"
                      :index="children.path"
                      v-if="isOptional(children)"
                      :data-testid="children.name"
                      class="flex items-center justify-start"
                      @click="clickMenu(children)"
                    >
                      {{ $t(children.name) }}
                      <div
                        v-if="
                          children.tag &&
                          !(
                            children.tag.id === 'verificationStatusTag' &&
                            accountAuditStatus === auditStatus.completed &&
                            idPass &&
                            poaPass
                          )
                        "
                        :class="children.tag.class"
                        class="ltr:ml-2 rtl:mr-2 flex items-center justify-center p-1 rounded-md text-white text-3xs"
                      >
                        {{ $t(children.tag.text) }}
                      </div>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </div>
            </div>
          </el-menu>
        </el-collapse-transition>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import blackList from '@/mixins/blackList';
import { NDB_CAMPAIGN_IDS, PROMOTION_TYPE_PATH_MAP, PROMOTION_WITH_CHILDS } from '@/constants/promotion';
import { deepCopy } from '@/util/utils';
import { NO_DEPOSIT_BONUS_PATHNAME, LOSS_RECOVER_PATHNAME } from '@/constants/route';
// import { HOW_TO_TRADE_COUNTRY } from '@/constants/protraderTools';
import { RegisterRoutePath } from '@/router/registerRoutes';
import auditStatus from '@/constants/auditStatus';
import { menuId } from '@/constants/menu';
import { Submenu } from 'element-ui';
import { SENSORS_TRACK, URL_TO_TAB_NAME } from '@/util/sensorsdata/constant';
import { sensorsTrack } from '@/util/sensorsdata';
import { apiAvailableLuckyPacket } from '@/resource';

function filterPromotion(menu, campaignEligibilityPath, currentLanguage) {
  menu = deepCopy(menu);
  let promotionMenu = menu.find(e => e.id === menuId.features).children.find(e => e.id === menuId.promotion);
  let usedMenu = [];
  // Always show /dailyNewsletter
  campaignEligibilityPath.push({ path: '/dailyNewsletter' });
  campaignEligibilityPath.forEach(item => {
    let found = promotionMenu.children.find(menu => menu.path == item.path);
    if (PROMOTION_WITH_CHILDS.map(item => item.type).includes(item.campaignType)) {
      let currentMenu = {
        id: item.id,
        clientPortalSettings: item.clientPortalSettings ? item.clientPortalSettings : [],
        name:
          item.clientPortalSettings?.find(value => value.languageCode == currentLanguage)?.title ??
          item.clientPortalSettings?.find(value => value.languageCode == 'en_US')?.title ??
          PROMOTION_WITH_CHILDS.find(promo => promo.type == item.campaignType)?.key,
        path: item.path
      };
      usedMenu.push(currentMenu);
    } else if (found && Object.keys(found).length > 0) {
      usedMenu.push(found);
    }
  });
  promotionMenu.children = usedMenu;
  return menu;
}

// function filterProTraderToolsHowToTrade(menu, countryCode) {
//   menu = deepCopy(menu);
//   if (!HOW_TO_TRADE_COUNTRY.includes(countryCode)) {
//     let tradingToolsMenu = menu.find(e => e.id === menuId.features).children.find(e => e.id === 'tradingTools');
//     tradingToolsMenu.children = tradingToolsMenu.children.filter(({ id }) => id !== 'howTrade');
//   }

//   return menu;
// }

export default {
  name: 'vMenu',
  props: {
    matches: Boolean,
    onOpen: Boolean
  },
  data() {
    return {
      bodyDirection: null,
      promotionRafEligibility: false,
      count: 0
    };
  },
  mixins: [blackList],
  methods: {
    matchesClose() {
      this.$emit('matchesClose');
    },
    checkMatchesClose() {
      const vm = this;
      this.$nextTick(function () {
        if (vm.matches) vm.matchesClose();
      });
    },
    clickMenu(children) {
      if (children.hasOwnProperty('externalLink')) {
        return window.open(children.externalLink(this.countryCode), '_blank', 'noopener,noreferrer');
      }
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.CRM_TAB_CLICK, {
        tab_name: URL_TO_TAB_NAME[children.path]
      });
      if (!children.hasOwnProperty('checkBlacklist')) {
        this.checkMatchesClose();
        this.$router.push({ path: children.path });
      } else {
        if (children.path === '/depositFunds') this.getDepositBlacklist();
        else if (children.path === '/transferFunds') this.goToTransferFunds();
        else this.getWithdrawalBlacklist();
      }
    },
    isOptional(children) {
      if (!children.hasOwnProperty('optional')) return children;
      else {
        if (this.openAdditionAccountEnabled) return children;
      }
    },
    checkRegister(menu) {
      return (menu.path != RegisterRoutePath.register || this.registerStep < 6) && !menu.children;
    },
    checkHomeUrl(path) {
      return path == '/home' && this.registerStep == 1 && this.isDemo ? '/homeDemo' : path;
    },
    checkCampaignEligibility() {
      this.$store.dispatch('promotion/actionGetEligibleCampaigns');
    },
    checkPropTradingEligibility() {
      this.$store.dispatch('propTrading/actionGetEligiblePropTrading');
    },
    isNDBActived({ paths = [], campaignParticipation = [] }) {
      if (paths.includes(NO_DEPOSIT_BONUS_PATHNAME)) {
        return true;
      }
      for (let i = 0; i < NDB_CAMPAIGN_IDS.length; i++) {
        if (campaignParticipation.includes(NDB_CAMPAIGN_IDS[i])) {
          return true;
        }
      }
      return false;
    },
    getLoyaltyInfo() {
      this.$store.dispatch('loyalty/actionGetLoyaltyInfo');
      this.$store.dispatch('loyalty/actionGetAvailableRewards');
    },
    filterLoyalty(menu, info) {
      menu = deepCopy(menu);
      if (info) {
        const isBlacklisted = info && (info.status === 3 || !info.eligible);

        if (isBlacklisted || !this.showLoyalty) {
          let featureMenu = menu.find(e => e.id === menuId.features);
          featureMenu.children = featureMenu.children.filter(({ id }) => id !== menuId.clubBleu);
        }
      }
      return menu;
    },
    filterPropTrading(menu) {
      const propTradingState = this.$store.state.propTrading;
      let featureMenu = menu.find(e => e.id === menuId.features);
      if (!propTradingState.eligible) {
        featureMenu.children = featureMenu.children.filter(({ id }) => id !== menuId.propTrade);
      } else if (!propTradingState.session && !propTradingState.account) {
        let filterData = ['menu.propTradeDashboard', 'menu.propTradeAchievement'];
        if (this.country == '6877') {
          filterData.push('menu.propTradeCreateAccount');
        }
        featureMenu.children = featureMenu.children.map(item => {
          if (item.name === 'menu.propTrade') {
            filterData.forEach(name => {
              const childIndex = item.children.findIndex(submenu => submenu.name === name);
              if (~childIndex) item.children.splice(childIndex, 1);
            });
          }
          return item;
        });
      } else if (this.country == '6877') {
        menu = menu.map(item => {
          if (item.name === 'menu.propTrade') {
            ['menu.propTradeCreateAccount'].forEach(name => {
              const childIndex = item.children.findIndex(submenu => submenu.name === name);
              if (~childIndex) item.children.splice(childIndex, 1);
            });
          }
          return item;
        });
      }
      return menu;
    },
    availableLuckyPacket() {
      apiAvailableLuckyPacket(55)
        .then(resp => {
          if (resp.data.code == 0) {
            const response = resp.data.data;
            this.count = response.count;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.auditStatus = auditStatus;
  },
  mounted() {
    if (this.accountAuditStatus !== auditStatus.completed) {
      this.$store.dispatch('common/actionAccountAuditStatus');
    }
    this.$store.dispatch('common/actionPoiAuditStatus');
    this.$store.dispatch('common/actionPoaAuditStatus');

    this.checkCampaignEligibility();
    this.getLoyaltyInfo();
    this.checkPropTradingEligibility();
    this.$nextTick(() => {
      this.bodyDirection = document.body.dir;
    });
    this.availableLuckyPacket();
  },
  watch: {
    $route(value) {
      if (value.path === '/home') {
        this.checkCampaignEligibility();
        this.getLoyaltyInfo();
      }
    }
  },
  computed: {
    filteredMenus() {
      let menu = this.$config.menu;
      const noCampaignEligibility = () =>
        this.campaignEligibility.length === 0 &&
        !this.isNDBActived({ campaignParticipation: this.campaignParticipation });

      if (noCampaignEligibility()) {
        menu = filterPromotion(this.$config.menu, [], this.$store.state.common.lang);
      } else {
        let paths = this.campaignEligibility
          .map(function (campaign) {
            return {
              ...campaign,
              path: PROMOTION_WITH_CHILDS.map(item => item.type).includes(campaign.campaignType)
                ? PROMOTION_TYPE_PATH_MAP[campaign.campaignType] + campaign.id
                : PROMOTION_TYPE_PATH_MAP[campaign.campaignType]
            };
          })
          .filter(e => e.path !== undefined && e.path !== null);
        if (
          this.isNDBActived({
            paths: paths.map(item => item.path),
            campaignParticipation: this.campaignParticipation
          })
        ) {
          paths.push({ path: NO_DEPOSIT_BONUS_PATHNAME });
        }
        menu = filterPromotion(this.$config.menu, paths, this.$store.state.common.lang);
      }

      menu = this.filterLoyalty(menu, this.loyaltyMemberInfo);
      // menu = filterProTraderToolsHowToTrade(menu, this.countryCode);

      // determine PropTrading
      menu = this.filterPropTrading(menu);

      return menu;
    },
    registerStep() {
      return this.$store.state.common.registerStep;
    },
    isDemo() {
      return this.$store.state.common.isDemo;
    },
    userTypeEnum() {
      return this.$store.state.common.userTypeEnum;
    },
    menu_wrapperStyle() {
      const direction = this.bodyDirection === 'rtl' ? { right: this.menuPosition } : { left: this.menuPosition };
      return { ...direction };
    },
    menuPosition() {
      return this.matches && !this.onOpen ? '-230px' : '0px';
    },
    campaignEligibility() {
      return this.$store.state.promotion.eligibleCampaigns;
    },
    campaignParticipation() {
      return this.$store.state.promotion.participatedCampaigns;
    },
    loyaltyMemberInfo() {
      return this.$store.state.loyalty.loyaltyInfo;
    },
    countryCode() {
      return parseInt(this.$store.state.common.countryCode);
    },
    openAdditionAccountEnabled() {
      return (
        this.openAccountEnabled &&
        this.idPass &&
        !this.$config.restrictOpenAdditionAccountCountries(this.regulator).includes(parseInt(this.countryCode))
      );
    },
    lang() {
      return this.$store.state.common.lang;
    },
    showLoyalty() {
      return this.$store.state.loyalty.showLoyalty;
    },
    ...mapState('common', ['openAccountEnabled', 'accountAuditStatus']),
    ...mapGetters('common', ['idPass', 'poaPass'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/layout/menu.scss';
</style>
